
import { FlowDraftItem } from '../types/resourceParts';
import { Request } from './Request';
import { ISingleIdParams } from '../types/actionParams';

export type GetFlowDraftResult = FlowDraftItem;

export class GetFlowDraftRequest extends Request<ISingleIdParams, GetFlowDraftResult> {
  constructor(params: ISingleIdParams) {
    super('getFlowDraft', params);
  }
}
